<template>
    <button
        class="flex items-center gap-1 rounded-xl p-2 text-sm font-light"
        @click="cartDialogStore.open()"
    >
        <IconCart class="inline h-8" /> <AnimatedNumber :number="data || 0" />
        <span class="font-medium">&#8381;</span>
    </button>
</template>

<script setup lang="ts">
    import { useCartDialogStore } from '~/store/cartDialog'
    const cartDialogStore = useCartDialogStore()
    const { data } = useBasket((v) => v.total_price)
</script>